import { render, staticRenderFns } from "./RentalLogin.vue?vue&type=template&id=6312f1df&scoped=true&"
import script from "./RentalLogin.vue?vue&type=script&lang=ts&"
export * from "./RentalLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6312f1df",
  null
  
)

export default component.exports